module.exports = __webpack_public_path__ + "static/assets/02030fe51808b37bb4836731787eb190.png";